import { useTheme } from "@mui/styles";
import { ImageDisplay, NameDisplay, } from "../../../OrderFlow/OrderFlowProvider/OrderFlowTypes";
import { hasIngredientOptionConflicts, isRecipeCustomizable } from "../CustomizeModal/CustomizeModal-utils";
import { useItemDetailCustomize } from "../ItemDetail/Customize/useItemDetailCustomize";
import { getCurrentCompatibilityType, getIngredientOptionsWithLowestSequence, getTitleSectionHeight, ItemCardType, } from "./itemCardUtils";
/**
 *
 * @param productAndRecipeCardLayoutSettings
 * @param itemShortName
 * @param itemName
 * @param itemChips
 * @param enableCustomization
 * @param compatibilityType
 * @param recipeAutoSelection
 * @param recipe
 * @param ingredientsToReplace
 * @param omissions
 * @returns
 */
export const useItemCard = (productAndRecipeCardLayoutSettings, recipeIngredientReplacementMode, itemType, assignmentCount, itemShortName, itemName, itemChips, itemImageUrls, enableCustomization, compatibilityType, recipeAutoSelection, recipe, ingredientsToReplace, omissions, alwaysPromptCustomizeModal) => {
    var _a;
    // @ts-ignore @MUI
    const { typography } = useTheme();
    const { currentRecipeAssignments } = useItemDetailCustomize(recipe);
    const lowestSeqIngredientOptions = getIngredientOptionsWithLowestSequence(ingredientsToReplace);
    // If any of the default selected ingredient options are a conflict the customize modal needs to open on plus click
    const shouldOpenCustomizeModal = isRecipeCustomizable(ingredientsToReplace) &&
        (hasIngredientOptionConflicts(lowestSeqIngredientOptions, omissions) ||
            alwaysPromptCustomizeModal ||
            assignmentCount > 1);
    //Map chips into an array of obj
    const allRecipeTypeChips = productAndRecipeCardLayoutSettings.DisplayRecipeTypes && itemChips
        ? itemChips.map((chip) => {
            return { label: chip, clickable: false };
        })
        : [];
    const { compatibilitySymbol, compatibilityType: currentCompatibilityType } = getCurrentCompatibilityType(compatibilityType, !!(currentRecipeAssignments === null || currentRecipeAssignments === void 0 ? void 0 : currentRecipeAssignments.some((assignment) => assignment.SelectedIngredientOptions.length > 0 && assignment.Quantity > 0)), ingredientsToReplace, omissions, recipeIngredientReplacementMode, enableCustomization, productAndRecipeCardLayoutSettings, recipeAutoSelection);
    //We're still only showing 2 line for title on products always.
    let desktopTitleLines = itemType == ItemCardType.Recipe ? productAndRecipeCardLayoutSettings.RecipeTitleLinesDesktop : 2;
    //We're still only showing 1 line for title on products always.
    let mobileTitleLines = itemType == ItemCardType.Recipe ? productAndRecipeCardLayoutSettings.RecipeTitleLinesMobile : 1;
    const desktopTitleSectionHeight = getTitleSectionHeight(typography, "h4", desktopTitleLines);
    const mobileTitleSectionHeight = getTitleSectionHeight(typography, "h4", mobileTitleLines);
    const imageDisplayModeToUse = itemType == ItemCardType.Recipe
        ? productAndRecipeCardLayoutSettings === null || productAndRecipeCardLayoutSettings === void 0 ? void 0 : productAndRecipeCardLayoutSettings.RecipeImageDisplayMode
        : productAndRecipeCardLayoutSettings === null || productAndRecipeCardLayoutSettings === void 0 ? void 0 : productAndRecipeCardLayoutSettings.ProductImageDisplayMode;
    const itemImagesForOverlay = imageDisplayModeToUse !== ImageDisplay.NoImage ? itemImageUrls !== null && itemImageUrls !== void 0 ? itemImageUrls : [] : null;
    return {
        itemDisplayName: productAndRecipeCardLayoutSettings.DisplayNameType == NameDisplay.ShortName && itemShortName
            ? itemShortName
            : itemName,
        isDetailOverlayEnabled: imageDisplayModeToUse === ImageDisplay.DetailsOverlay,
        recipeTypeChips: allRecipeTypeChips,
        productAndRecipeCardLayoutSettings: productAndRecipeCardLayoutSettings,
        defaultDescriptionLines: (_a = productAndRecipeCardLayoutSettings.DescriptionLines) !== null && _a !== void 0 ? _a : 3,
        showItemImages: imageDisplayModeToUse === ImageDisplay.NoImage ? false : true,
        // the DoNotDisplayOnMobile & DisplaySymbolFlags settings affect recipe cards only, not products
        displayOnMobile: productAndRecipeCardLayoutSettings.DisplayOnMobile,
        showSymbolFlagsOnDesktop: productAndRecipeCardLayoutSettings.DisplaySymbolFlags,
        showDescription: productAndRecipeCardLayoutSettings.DisplayDescription,
        showCompatibilityIcon: productAndRecipeCardLayoutSettings.DisplayRecipeCompatibilitySymbols,
        currentCompatibilityType,
        compatibilitySymbol,
        shouldOpenCustomizeModal,
        desktopTitleLines,
        mobileTitleLines,
        desktopTitleSectionHeight,
        mobileTitleSectionHeight,
        itemImagesForOverlay,
    };
};
